import React from "react";
import { useState, useEffect } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

import { green, yellow } from "@mui/material/colors";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const DemoPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: "left",
}));

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
}));

function generate(element) {
  return [0, 1, 2].map((value) =>
    React.cloneElement(element, {
      key: value,
    })
  );
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

export default function Orders() {
  const [dense, setDense] = useState(false);
  const [secondary, setSecondary] = useState(false);
  const [open, setOpen] = useState(false);
  const [deliveryStatus, setDeliveryStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");

  const handleDeliveryChange = (event) => {
    setDeliveryStatus(event.target.value || "");
  };

  const handlePaymentChange = (event) => {
    setPaymentStatus(event.target.value || "");
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  return (
    <div className="AddProducts">
      <Stack direction="column">
        <DemoPaper variant="outlined">
          {" "}
          <Stack direction="column" spacing={0}>
            {" "}
            <Stack
              direction="row"
              alignItems="flex-end"
              justifyContent="space-between"
            >
              <Container>
                <h2>Orders</h2>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link underline="hover" color="inherit" href="/">
                    MUI
                  </Link>
                  <Link
                    underline="hover"
                    color="inherit"
                    href="/material-ui/getting-started/installation/"
                  >
                    Core
                  </Link>
                  <Link
                    underline="hover"
                    color="text.primary"
                    href="/material-ui/react-breadcrumbs/"
                    aria-current="page"
                  >
                    Breadcrumbs
                  </Link>
                </Breadcrumbs>
              </Container>{" "}
              <Grid
                container
                justifyContent="flex-end"
                alignItems="center"
                spacing={1}
              >
                <Grid item xs="auto">
                  {" "}
                  <Button variant="outlined" color="error">
                    Discard Changes
                  </Button>
                </Grid>
                <Grid item xs="auto">
                  <Button variant="contained">Add Product</Button>{" "}
                </Grid>
              </Grid>
            </Stack>
          </Stack>
        </DemoPaper>
      </Stack>
      {/* <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
        Avatar with text and icon
      </Typography> */}

      <Grid container direction={"column"} spacing={1}>
        <Box component="section" sx={{ p: 1 }}>
          <Item>
            <Grid container direction={"column"} sx={{ p: 1.5 }} spacing={1}>
              <Grid
                container
                direction={"row"}
                sx={{
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <Box sx={{ textAlign: "left" }}>
                  <h3>Order No. 01</h3>
                </Box>

                <Box>
                  <i>May 17, 2025</i>
                </Box>
              </Grid>
              <Demo>
                <List dense={dense}>
                  {generate(
                    <ListItem
                      secondaryAction={
                        <IconButton edge="end" aria-label="delete">
                          <DeleteIcon />
                        </IconButton>
                      }
                    >
                      <ListItemAvatar>
                        <Avatar>
                          <FolderIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary="Single-line item"
                        // secondary={secondary ? "Secondary text" : null}
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="body2"
                              sx={{ color: "text.primary", display: "inline" }}
                            >
                              Sandra Adams
                            </Typography>
                            {
                              " — Do you have Paris recommendations? Have you ever…"
                            }
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                  )}
                </List>
              </Demo>
              <hr />{" "}
              <Grid
                container
                direction={"row"}
                sx={{ justifyContent: "space-between" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span>GRAB DELIVERY</span>
                  <i style={{ fontSize: "x-small" }}>Pending</i>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontSize: "large" }}>
                    Total: <b style={{ fontSize: "xx-large" }}> ₱100</b>
                  </span>{" "}
                  <span style={{ fontSize: "small" }}>Bank Transfer - BDO</span>
                  <i style={{ fontSize: "x-small" }}>Waiting for payment</i>
                </Box>
              </Grid>
            </Grid>

            <div>
              <Button onClick={handleClickOpen}>Update order status</Button>
              <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
                <DialogTitle>Update order status</DialogTitle>
                <DialogContent>
                  <Box
                    component="form"
                    sx={{ display: "flex", flexWrap: "wrap" }}
                  >
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                      <InputLabel htmlFor="demo-dialog-native">
                        Delivery
                      </InputLabel>
                      <Select
                        native
                        value={deliveryStatus}
                        onChange={handleDeliveryChange}
                        input={
                          <OutlinedInput
                            label="Delivery Status"
                            id="demo-dialog-native"
                          />
                        }
                      >
                        <option value={"Pending"}>Pending</option>
                        <option value={"Shipped"}>Shipped</option>
                        <option value={"Delivered"}>Delivered</option>
                      </Select>
                    </FormControl>
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                      <InputLabel id="demo-dialog-select-label">
                        Payment
                      </InputLabel>
                      <Select
                        labelId="demo-dialog-select-label"
                        id="demo-dialog-select"
                        value={paymentStatus}
                        onChange={handlePaymentChange}
                        input={<OutlinedInput label="Payment Status" />}
                      >
                        <MenuItem value={"Unpaid"}>Unpaid</MenuItem>
                        <MenuItem value={"Paid"}>Paid</MenuItem>
                        <MenuItem value={"Failed"}>Failed</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button onClick={handleClose}>Ok</Button>
                </DialogActions>
              </Dialog>
            </div>
          </Item>
        </Box>
      </Grid>
    </div>
  );
}
